import { BarChart3, Boxes, Building2, ChartNoAxesCombined, CircleDollarSign, LayoutDashboard, ShoppingBag, ShoppingCart, UsersRound, Warehouse } from "lucide-react";
export const furnituraNavigation = [
    { path: "dashboard", label: "Обзор фурнитуры", icon: LayoutDashboard },
    { path: "products", label: "Товары", icon: Boxes },
    { path: "stock", label: "Склад фурнитуры", icon: Warehouse },
    { path: "purchases", label: "Закупки из Китая", icon: ShoppingBag },
    { path: "suppliers", label: "Поставщики", icon: Building2 },
    { path: "sales", label: "Продажи фурнитуры", icon: ShoppingCart },
    { path: "customers", label: "Клиенты", icon: UsersRound },
    { path: "payments", label: "Оплаты и долги", icon: CircleDollarSign },
    { path: "profit", label: "Прибыль и расходы", icon: ChartNoAxesCombined },
    { path: "reports", label: "Отчёты фурнитуры", icon: BarChart3 },
];
